export { Details } from './Page'
